module.exports = __webpack_public_path__ + "static/media/PrimarySchool.0eb6d0ab.png";